import axios from './axiosInterceptors';

const API_URL = "/api/v1/transfer-at-source/";

const importExcelTransactions = (formData, rawExcelData, confirmWithWarning) => {
    return axios
        .post(API_URL + "import-excel-data",
            { formData, rawExcelData, confirmWithWarning }).then((response) => {
                return response.data;
            });
};

const allActions = {
    importExcelTransactions,
};

export default allActions;